<ngx-spinner bdColor="rgba(36,34,36,0.8)" size="custom" style="width: 80px; height: 80px;" color="#81c784" type="timer">
  <p style="font-size: 20px; color: white; z-index: 9999999;">Getting remote localization tables...</p>
</ngx-spinner>

<ng-container *ngIf="error">
  <p-message severity="error" text="{{ error }}"></p-message>
  <br/>
  <p-messages severity="warn">
    <ng-template pTemplate>
      <i class="pi pi-info-circle"></i>
      <div class="p-ml-2">
        Stay <strong>on the VPN</strong> so the worker can reach the Aurora reader.
      </div>
    </ng-template>
  </p-messages>
  <br/>
  <p-button label="Retry" icon="pi pi-refresh" class="p-button-primary" (click)="loader()"></p-button>
</ng-container>

<ng-container *ngIf="sourceTables">
  <p-messages severity="info">
    <ng-template pTemplate>
      <i class="pi pi-info-circle"></i>
      <div class="p-ml-2">
        Local only. Selected tables are copied from production <strong>localization</strong> (Aurora reader) into your local MySQL.
        This does not use the Builder queue — progress is shown below.
      </div>
    </ng-template>
  </p-messages>
  <br/>
  <ng-container *ngIf="inProgressMessage">
    <p-messages severity="warn">
      <ng-template pTemplate>
        <i class="pi pi-info-circle"></i>
        <div class="p-ml-2">{{ inProgressMessage }}</div>
      </ng-template>
    </p-messages>
  </ng-container>
  <div *ngIf="status" class="p-mb-3" style="font-size: 0.9rem; color: #555;">
    <span *ngIf="status.inProgress">
      <i class="pi pi-spin pi-spinner"></i>
      Copying <strong>{{ status.currentTable || '…' }}</strong>
      — {{ status.tablesDone }}/{{ status.tablesTotal }} tables,
      {{ status.rowsCopied }} rows
      <span *ngIf="status.startedBy"> (started by {{ status.startedBy }})</span>
    </span>
    <span *ngIf="!status.inProgress && status.lastStatus === 'success'" style="color: #2e7d32;">
      <i class="pi pi-check-circle"></i> {{ status.lastMessage }}
    </span>
    <span *ngIf="!status.inProgress && status.lastStatus === 'failed'" style="color: #c62828;">
      <i class="pi pi-times-circle"></i> {{ status.lastMessage }}
    </span>
  </div>
  <p-button
    label="Sync to Local"
    icon="pi pi-refresh"
    class="p-button-primary"
    [disabled]="status?.inProgress"
    (click)="syncToLocal()">
  </p-button>
  <br/><br/>
  <p-pickList
    [source]="sourceTables"
    [target]="targetTables"
    sourceHeader="Available to sync"
    targetHeader="To process in the sync"
    [dragdrop]="true"
    [showSourceControls]="false"
    [showTargetControls]="false"
    sourceFilterPlaceholder="Search by name"
    targetFilterPlaceholder="Search by name"
    [responsive]="true"
    filterBy="name"
    [sourceStyle]="{ height: '30rem' }"
    [targetStyle]="{ height: '30rem' }"
  >
    <ng-template let-item pTemplate="item">
      <div>{{ item.name }}</div>
    </ng-template>
  </p-pickList>
</ng-container>

<p-toast></p-toast>
